import { FC, ReactNode, createContext, useContext, useState } from 'react';
import { Quiz } from '@teachur/http-client';

export type ExamMode =
  | { type: 'notStarted' }
  | { type: 'intro' }
  | { type: 'loading'; attempt: Quiz }
  | { type: 'question'; attempt: Quiz }
  | { type: 'result'; attempt: Quiz };

interface ExamContextValue {
  examMode: ExamMode;
  setExamMode: (mode: ExamMode) => void;
  exitExam: () => void;
}

const ExamContext = createContext<ExamContextValue | null>(null);

interface ExamProviderProps {
  children: ReactNode;
}

export const ExamProvider: FC<ExamProviderProps> = ({ children }) => {
  const [examMode, setExamMode] = useState<ExamMode>({ type: 'notStarted' });

  const onChange = (exam: ExamMode) => {
    console.log('uslo', exam);
    setExamMode((prev) => ({ ...prev, ...exam }));
  };

  const exitExam = () => {
    setExamMode({ type: 'notStarted' });
  };

  const value: ExamContextValue = {
    examMode,
    setExamMode: onChange,
    exitExam,
  };

  return <ExamContext.Provider value={value}>{children}</ExamContext.Provider>;
};

export const useExamContext = (): ExamContextValue => {
  const context = useContext(ExamContext);

  if (!context) {
    throw new Error('useExamContext must be used within ExamProvider');
  }

  return context;
};
